import {
    BOOKING_LIST,
    BOOKING_PAGINATION,
    BOOKING_SUMMARY,
    BOOKING_CANCEL_LIST,
    BOOKING_CANCEL_PAGINATION,
    BOOKING_CANCEL_SUMMARY
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getBookingList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `v1/Booking/GetBookingList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: BOOKING_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: BOOKING_PAGINATION,
                    payload: result?.pagination || {},
                });
                dispatch({
                    type: BOOKING_SUMMARY,
                    payload: result?.summary || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 *  https://api.shipez.ai/api/v1/Booking/InactiveBookingByID?BookingId=12&ModifiedBy=admin
 * @param {*} payload 
 * @returns 
 */
export const deletebookingDetails = (payload) => {
    const queryParams = new URLSearchParams({
        ...payload,
    }).toString();
    const url = `v1/Booking/InactiveBookingByID?${queryParams}`;
    return APICall('Get', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getBookingList(payList);

            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getCancelBookingList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `v1/Booking/GetCancelledBookingList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: BOOKING_CANCEL_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: BOOKING_CANCEL_PAGINATION,
                    payload: result?.pagination || {},
                });
                dispatch({
                    type: BOOKING_CANCEL_SUMMARY,
                    payload: result?.summary || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getBookingDetails = (payload,companyId) => {
    return dispatch => {
        const url = `v2/Booking/GetBookingByID?BookingId=${payload}&compnayId=${companyId}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const addBookingDetails = (payload) => {

    const url = `v2/Booking/CreateBooking`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getBookingList(payList);

            return result;

        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 *  
 * @param {*} payload 
 * @returns 
 */
export const updateBookingDetails = (payload) => {
    const url = `v2/Booking/UpdateBooking`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            await getBookingList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};



/**
 *  
 * @param {*} payload 
 * @returns 
 */
export const getHBLByID = (payload) => {
    const url = `v1/HBL/GetHBLByID?BookingId=${payload}`;
    return APICall('get', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 *  
 * @param {*} payload 
 * @returns 
 */
export const UpdateHBL = (payload) => {
    const url = `v1/HBL/UpdateHBL`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};


/*
* https://api.shipez.ai/api/v1/MBL/GetMBLByID?BookingId=1116
* @param {*} payload 
* @returns 
*/
export const GetMBLDetails = (payload) => {
    return dispatch => {
        const url = `v1/MBL/GetMBLByID?BookingId=${payload}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 *  /api/v1/MBL/UpdateMBL
 * @param {*} payload 
 * @returns 
 */
export const updateMBLDetails = (payload) => {
    const url = `v1/MBL/UpdateMBL`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};


/*
* https://api.shipez.ai/api/v1/MBL/GetMBLByID?BookingId=1116
* @param {*} payload 
* @returns 
*/
export const GetHBLDetails = (payload) => {
    return dispatch => {
        const url = `v1/HBL/GetHBLByID?BookingId=${payload}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 *  /api/v1/MBL/UpdateMBL
 * @param {*} payload 
 * @returns 
 */
export const updateHBLDetails = (payload) => {
    const url = `v1/HBL/UpdateHBL`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};


export const getStatusAuditDetails = (BookingId) => {
    return dispatch => {
        const url = `v1/Booking/GetStatusAudit?BookingId=${BookingId}`;
        return APICall('get', null, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const updateStatusAuditDetails = (payload) => {
    return dispatch => {
        const url = `v1/Booking/UpdateStatusAudit`;
        return APICall('post', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const updateDockReceipt = (payload) => {
    return dispatch => {
        const url = `v1/Booking/UpdateDocRecipt`;
        return APICall('post', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


export const getDockReceipt = (BookingId) => {
    return dispatch => {
        const url = `v1/Booking/GetDockReceipt?BookingId=${BookingId}`;
        return APICall('get', null, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const deleteBookingList = (payload) => {
    const url = `v1/Booking/DeleteBookingList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const reinstateBookingList = (payload) => {
    const url = `v1/Booking/ReinstateBookingList`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};


//hanlde change for charge code dropdown in accounting invoice and bill page
export const getChargeCodes = (keyword = "", flag = 0) => {
    return async () => {
        const searchValue = keyword && keyword.trim() ? keyword : "o"; // ✅ no empty

        const url = `v1/Common/ChargesDescription_List?flag=${flag}&searchKeyword=${searchValue}`;

        const result = await APICall("get", {}, url);

        return result?.data || []; // ✅ your API already array
    };
};



/**
 * 
 * @param {*} payload 
 * @returns 
 * https://api.shipez.ai/api/v1/Booking/SyncArAp
 */
export const SyncArAp = (payload) => {
    const url = `v1/Booking/SyncArAp`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            return result;
        } else {
            return false;
        }
    }, error => {
        return Promise.reject(error);
    });
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */

export const GetVesselSchedule = (payload) => {
    return dispatch => {
        // Convert object to query string for GET
      const params = new URLSearchParams(payload).toString();
        const url = `v1/FCLRateQuoteSearch/VesselSearch?${params}`;
        return APICall('get', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};



/**
 * Get Arrival Notice List
 * @param {*} payload { BolID, CompanyID }
 */
export const getArrivalNoticeList = (payload) => {
    return (dispatch) => {
        const { BolID, CompanyID } = payload || {};

        const url = `v1/Arrival_Import/GetArrivalNotice?BolID=${BolID}&CompanyID=${CompanyID}`;

        return APICall("get", null, url)
            .then(
                (result) => {
                    if (result?.statuscode === 200 || result?.statuscode === 201) {
                        return result?.data;
                    } else {
                        return Promise.reject(result);
                    }
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
    };
};
